import m from "../../geodata/es2015/stKittsNevisHigh";
window.am4geodata_stKittsNevisHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/stKittsNevisHigh.js
// module id = null
// module chunks = 